import * as React from "react";

export const ArthaLinkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={41} height={41} rx={5.5} fill="white" />
    <rect x={0.5} y={0.5} width={41} height={41} rx={5.5} stroke="black" />
    <path
      d="M31.0033 33.8858C29.4272 29.0822 25.6284 25.3376 20.8712 23.9576C15.9622 25.3902 12.0579 29.1405 10.454 33.9274L10.4324 33.9921L8.30975 33.7258C8.49655 30.0348 9.97837 26.6808 12.3152 24.0988L12.325 24.0879C14.5146 21.6729 17.453 19.935 20.7792 19.2304C23.9025 19.8867 26.6864 21.4397 28.8372 23.6011L28.8723 23.6813L28.8965 23.7365L28.992 23.7589C31.5189 26.3702 33.1362 29.8362 33.3459 33.6688L31.0273 33.9597L31.0033 33.8858Z"
      fill="url(#paint0_linear_750_17810)"
    />
    <g filter="url(#filter0_f_750_17810)">
      <path
        d="M9.49688 33.5086L9.85056 29.7351L10.2325 27.9306L10.9969 25.6451L11.9783 23.6702"
        stroke="#101828"
        strokeWidth={0.670986}
      />
    </g>
    <g filter="url(#filter1_f_750_17810)">
      <path
        d="M32.1476 33.4232L31.776 29.4579L31.3746 27.5617L30.5714 25.1602L29.5401 23.0849"
        stroke="#101828"
        strokeWidth={0.670986}
      />
    </g>
    <path
      d="M15.3177 11.9964C16.9485 10.7403 18.733 9.72653 20.6318 9C22.5474 9.73637 24.3458 10.7676 25.9869 12.0471C29.1704 14.5293 31.761 17.9456 33.4628 21.9547C34.0985 23.4524 34.6102 25.0327 34.9824 26.6781C35.4471 28.732 35.6944 30.8871 35.6944 33.1088L35.6943 33.1762L35.694 33.2732L35.6932 33.3767L33.3408 33.672L31.0078 33.9855V33.8883C31.0119 33.7938 31.0156 33.6991 31.0188 33.6042C31.0222 33.5036 31.025 33.4028 31.0272 33.3019C31.0314 33.109 31.0335 32.9155 31.0335 32.7213C30.8488 29.5441 30.0955 26.5034 28.9097 23.7744C28.8566 23.6522 28.9326 23.8252 28.8506 23.6395C28.1214 21.9876 27.2335 20.4519 26.2173 19.0717C24.6703 16.9706 22.8262 15.2299 20.7929 13.9883C18.7096 15.2342 16.8223 16.9803 15.2492 19.0906C14.1245 20.5996 13.1604 22.2948 12.4003 24.1266L12.3966 24.1355C11.3067 26.7651 10.6369 29.6759 10.5155 32.7213C10.5155 33.1269 10.5248 33.5299 10.5431 33.9298L10.5216 33.9942L8.4077 33.7289L5.50109 33.364L5.50049 33.2716C5.5002 33.2173 5.5 33.163 5.5 33.1088C5.5 31.5067 5.62923 29.9394 5.8763 28.4196C6.22341 26.2848 6.80295 24.2439 7.58396 22.3329C9.30042 18.1327 11.9892 14.5599 15.3177 11.9964Z"
      fill="white"
    />
    <path
      d="M15.3177 11.9964C16.9485 10.7403 18.733 9.72653 20.6318 9C22.5474 9.73637 24.3458 10.7676 25.9869 12.0471C29.1704 14.5293 31.761 17.9456 33.4628 21.9547C34.0985 23.4524 34.6102 25.0327 34.9824 26.6781C35.4471 28.732 35.6944 30.8871 35.6944 33.1088L35.6943 33.1762L35.694 33.2732L35.6932 33.3767L33.3408 33.672L31.0078 33.9855V33.8883C31.0119 33.7938 31.0156 33.6991 31.0188 33.6042C31.0222 33.5036 31.025 33.4028 31.0272 33.3019C31.0314 33.109 31.0335 32.9155 31.0335 32.7213C30.8488 29.5441 30.0955 26.5034 28.9097 23.7744C28.8566 23.6522 28.9326 23.8252 28.8506 23.6395C28.1214 21.9876 27.2335 20.4519 26.2173 19.0717C24.6703 16.9706 22.8262 15.2299 20.7929 13.9883C18.7096 15.2342 16.8223 16.9803 15.2492 19.0906C14.1245 20.5996 13.1604 22.2948 12.4003 24.1266L12.3966 24.1355C11.3067 26.7651 10.6369 29.6759 10.5155 32.7213C10.5155 33.1269 10.5248 33.5299 10.5431 33.9298L10.5216 33.9942L8.4077 33.7289L5.50109 33.364L5.50049 33.2716C5.5002 33.2173 5.5 33.163 5.5 33.1088C5.5 31.5067 5.62923 29.9394 5.8763 28.4196C6.22341 26.2848 6.80295 24.2439 7.58396 22.3329C9.30042 18.1327 11.9892 14.5599 15.3177 11.9964Z"
      fill="url(#paint1_linear_750_17810)"
    />
    <path
      d="M15.3177 11.9964C16.9485 10.7403 18.733 9.72653 20.6318 9C22.5474 9.73637 24.3458 10.7676 25.9869 12.0471C29.1704 14.5293 31.761 17.9456 33.4628 21.9547C34.0985 23.4524 34.6102 25.0327 34.9824 26.6781C35.4471 28.732 35.6944 30.8871 35.6944 33.1088L35.6943 33.1762L35.694 33.2732L35.6932 33.3767L33.3408 33.672L31.0078 33.9855V33.8883C31.0119 33.7938 31.0156 33.6991 31.0188 33.6042C31.0222 33.5036 31.025 33.4028 31.0272 33.3019C31.0314 33.109 31.0335 32.9155 31.0335 32.7213C30.8488 29.5441 30.0955 26.5034 28.9097 23.7744C28.8566 23.6522 28.9326 23.8252 28.8506 23.6395C28.1214 21.9876 27.2335 20.4519 26.2173 19.0717C24.6703 16.9706 22.8262 15.2299 20.7929 13.9883C18.7096 15.2342 16.8223 16.9803 15.2492 19.0906C14.1245 20.5996 13.1604 22.2948 12.4003 24.1266L12.3966 24.1355C11.3067 26.7651 10.6369 29.6759 10.5155 32.7213C10.5155 33.1269 10.5248 33.5299 10.5431 33.9298L10.5216 33.9942L8.4077 33.7289L5.50109 33.364L5.50049 33.2716C5.5002 33.2173 5.5 33.163 5.5 33.1088C5.5 31.5067 5.62923 29.9394 5.8763 28.4196C6.22341 26.2848 6.80295 24.2439 7.58396 22.3329C9.30042 18.1327 11.9892 14.5599 15.3177 11.9964Z"
      fill="url(#paint2_linear_750_17810)"
    />
    <defs>
      <filter
        id="filter0_f_750_17810"
        x={7.06601}
        y={21.424}
        width={7.30957}
        height={14.2126}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={1.04842}
          result="effect1_foregroundBlur_750_17810"
        />
      </filter>
      <filter
        id="filter1_f_750_17810"
        x={27.1429}
        y={20.8388}
        width={7.43567}
        height={14.7125}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={1.04842}
          result="effect1_foregroundBlur_750_17810"
        />
      </filter>
      <linearGradient
        id="paint0_linear_750_17810"
        x1={20.8488}
        y1={29.9452}
        x2={20.9917}
        y2={19.232}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0D41E1" />
        <stop offset={1} stopColor="#07C8F9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_750_17810"
        x1={20.7079}
        y1={9}
        x2={20.4006}
        y2={33.9932}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FC7C01" />
        <stop offset={0.699677} stopColor="#F76173" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_750_17810"
        x1={19.4975}
        y1={16.236}
        x2={19.1938}
        y2={33.7502}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F15FAD" />
        <stop offset={0.6} stopColor="#F76173" />
      </linearGradient>
    </defs>
  </svg>
);
